import { render } from "./AddPurchase.vue?vue&type=template&id=50f2e42a"
import script from "./AddPurchase.vue?vue&type=script&lang=js"
export * from "./AddPurchase.vue?vue&type=script&lang=js"

import "./AddPurchase.vue?vue&type=style&index=0&id=50f2e42a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__